export enum ReviewViewType {
  LIST = 'list',
  SLIDE = 'slide',
}
